export default "__VITE_ASSET__rlkcMGuu__"